<script>
    import MBaseFormPicker from "@/assets/plugins/mps-form/providers/MBaseFormPicker";
    import {isNOU} from "@/assets/plugins/mps-common/expansions/condition";

    export default {
        name: "MFormAccountPicker",
        extends: MBaseFormPicker,
        computed: {
            display() {
                if (!this.options) return null;
                let _t = "";
                if (!!this.options.accountName) _t += this.options.accountName;
                if (!!this.options.accountId) _t += "[" + this.options.accountId + "]";
                return _t;
            },

            titleComputed() {
                return null;
            },
        },
        watch: {
            options: {
                deep: true,
                handler: function () {
                    if (isNOU(this.options.accountId)) { // 오직 초기화 목적!
                        this.model = this.options.accountId;
                    }
                }
            }
        },
    }
</script>